import api, { handleResponse, handleError } from './api';

/** Admin control plane for Listed Pros — /admin/listed-pros. */
const wrap = async (call) => { try { return handleResponse(await call()); } catch (e) { return handleError(e); } };

const listedProAdminService = {
  health: () => wrap(() => api.get('/admin/listed-pros/health')),
  startRun: (regionId, crafts) => wrap(() => api.post(`/admin/listed-pros/regions/${regionId}/runs`, { crafts })),
  listRuns: (params = {}) => wrap(() => api.get('/admin/listed-pros/runs', { params })),
  getRun: (id) => wrap(() => api.get(`/admin/listed-pros/runs/${id}`)),
  cancelRun: (id) => wrap(() => api.post(`/admin/listed-pros/runs/${id}/cancel`)),
  // Carry on a run that stopped partway — keeps the crafts already researched.
  resumeRun: (id) => wrap(() => api.post(`/admin/listed-pros/runs/${id}/resume`)),
  businesses: (params = {}) => wrap(() => api.get('/admin/listed-pros/businesses', { params })),
  action: (id, action) => wrap(() => api.post(`/admin/listed-pros/businesses/${id}/${action}`)),
};

export default listedProAdminService;
